import { render } from "./HeaderSection.vue?vue&type=template&id=f9078fca&scoped=true"
const script = {}

import "./HeaderSection.vue?vue&type=style&index=0&id=f9078fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9078fca"]])

export default __exports__